import React, { Component } from 'react';
import { string, number, bool } from 'prop-types';

class Clipboard extends Component {
  shouldComponentUpdate(nextProps) {
    const { size, color } = this.props;

    return size !== nextProps.size || color !== nextProps.color;
  }

  render() {
    const { size, color, dev } = this.props;

    if (dev) console.log('rendering ICON component', this);

    return (
      <svg version={'1.1'} xmlns={'http://www.w3.org/2000/svg'} width={1 * size} height={size} viewBox={'0 0 32 32'}>
        {/* <title>Crehanaicons-1562</title> */}
        <path fill={color} d={'M13.757 19.868c-0.416 0-0.832-0.159-1.149-0.476-2.973-2.973-2.973-7.81 0-10.783l6-6c1.44-1.44 3.355-2.233 5.392-2.233s3.951 0.793 5.392 2.233c2.973 2.973 2.973 7.81 0 10.783l-2.743 2.743c-0.635 0.635-1.663 0.635-2.298 0s-0.635-1.663 0-2.298l2.743-2.743c1.706-1.706 1.706-4.481 0-6.187-0.826-0.826-1.925-1.281-3.094-1.281s-2.267 0.455-3.094 1.281l-6 6c-1.706 1.706-1.706 4.481 0 6.187 0.635 0.635 0.635 1.663 0 2.298-0.317 0.317-0.733 0.476-1.149 0.476z'} />
        <path fill={color} d={'M8 31.625c-2.037 0-3.952-0.793-5.392-2.233-2.973-2.973-2.973-7.81 0-10.783l2.743-2.743c0.635-0.635 1.664-0.635 2.298 0s0.635 1.663 0 2.298l-2.743 2.743c-1.706 1.706-1.706 4.481 0 6.187 0.826 0.826 1.925 1.281 3.094 1.281s2.267-0.455 3.094-1.281l6-6c1.706-1.706 1.706-4.481 0-6.187-0.635-0.635-0.635-1.663 0-2.298s1.663-0.635 2.298 0c2.973 2.973 2.973 7.81 0 10.783l-6 6c-1.44 1.44-3.355 2.233-5.392 2.233z'} />
      </svg>

    );
  }
}

Clipboard.defaultProps = {
  color: '#555',
  size: 32,
  dev: false,
};

Clipboard.propTypes = {
  color: string,
  size: number,
  /* Use this prop if u want to log the re-renders of the icon component */
  dev: bool,
};

export default Clipboard;
